module.exports = __webpack_public_path__ + "static/media/arrow-right-white.bb8afe33.svg";